import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const TermsAndConditions = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>Terms &amp; Conditions</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <p>your data goes here</p>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(TermsAndConditions);
